import type { TechFormValidationConfig } from "./tech-form-validation.models";

export const CURRENT_TECH_FORM_SCHEMA_VERSION = 1;

// Mirrored in the online and offline repositories. The parity test protects this contract.
export const TECH_FORM_VALIDATION_CONFIG: TechFormValidationConfig = {
  fields: [
    {
      section: 1,
      key: "vesselName",
      label: "Vessel name",
      type: "text",
      required: true,
    },
    {
      section: 1,
      key: "imoNumber",
      label: "IMO number",
      type: "imo",
      required: true,
    },
    {
      section: 1,
      key: "contactDetails.0.communicationType",
      label: "First contact communication type",
      type: "choice",
      required: true,
      choices: ["Email"],
    },
    {
      section: 1,
      key: "contactDetails.0.details",
      label: "First contact email address",
      type: "text",
      required: true,
    },
    {
      section: 1,
      key: "gtNt",
      label: "GT / NT",
      type: "gtNt",
      required: true,
    },
    {
      section: 1,
      key: "heightOfVessel",
      label: "Height of vessel",
      type: "number",
      required: true,
      min: 20,
      max: 100,
    },
    {
      section: 1,
      key: "loa",
      label: "LOA",
      type: "number",
      required: true,
      min: 100,
      max: 400,
    },
    {
      section: 1,
      key: "lbp",
      label: "LBP",
      type: "number",
      required: true,
      min: 90,
      max: 390,
    },
    {
      section: 1,
      key: "beam",
      label: "Beam",
      type: "number",
      required: true,
      min: 18,
      max: 70,
    },
    {
      section: 1,
      key: "lightWeight",
      label: "Lightweight",
      type: "number",
      required: true,
      min: 0,
      max: 90000,
    },
    {
      section: 1,
      key: "totalHoldCapacityGrainM3",
      label: "Grain hold capacity",
      type: "number",
      required: true,
      min: 0,
      max: 250000,
    },
    {
      section: 1,
      key: "totalHoldCapacityBaleM3",
      label: "Bale hold capacity",
      type: "number",
      required: true,
      min: 0,
      max: 250000,
    },
    {
      section: 1,
      key: "constant",
      label: "Constant",
      type: "number",
      required: true,
      min: 0,
      minInclusive: true,
      max: 10000,
    },
    {
      section: 1,
      key: "blockCoeficient",
      label: "Block coefficient",
      type: "number",
      required: true,
      min: 0,
      max: 1,
    },
    {
      section: 1,
      key: "mouldedDepth",
      label: "Moulded depth",
      type: "number",
      required: true,
    },
    {
      section: 1,
      key: "freshWaterCapacity",
      label: "Freshwater capacity",
      type: "number",
      required: true,
    },
    {
      section: 1,
      key: "maxCraneOutReach",
      label: "Crane outreach",
      type: "number",
      required: false,
    },
    {
      section: 1,
      key: "ConfirmShipHasRightHandedPropeller",
      label: "Right-handed propeller",
      type: "choice",
      required: true,
      choices: ["yes", "no"],
    },
    {
      section: 1,
      key: "Anymodificationsmadesincenewbuiltthataffectconsumption",
      label: "Modifications affecting consumption",
      type: "choice",
      required: true,
      choices: ["yes", "no"],
    },
    {
      section: 1,
      key: "wlthc.ballast.no1",
      label: "WLTHC ballast no1",
      type: "number",
      required: true,
    },
    {
      section: 1,
      key: "wlthc.ballast.midships",
      label: "WLTHC ballast midships",
      type: "number",
      required: true,
    },
    {
      section: 1,
      key: "wlthc.ballast.last",
      label: "WLTHC ballast last",
      type: "number",
      required: true,
    },
    {
      section: 1,
      key: "wlthc.fullBallast.no1",
      label: "WLTHC full ballast no1",
      type: "number",
      required: true,
    },
    {
      section: 1,
      key: "wlthc.fullBallast.midships",
      label: "WLTHC full ballast midships",
      type: "number",
      required: true,
    },
    {
      section: 1,
      key: "wlthc.fullBallast.last",
      label: "WLTHC full ballast last",
      type: "number",
      required: true,
    },
    {
      section: 1,
      key: "wlthc.fullyLaden.no1",
      label: "WLTHC fully laden no1",
      type: "number",
      required: true,
    },
    {
      section: 1,
      key: "wlthc.fullyLaden.midships",
      label: "WLTHC fully laden midships",
      type: "number",
      required: true,
    },
    {
      section: 1,
      key: "wlthc.fullyLaden.last",
      label: "WLTHC fully laden last",
      type: "number",
      required: true,
    },
    {
      section: 2,
      key: "alternateHoldLoading",
      label: "Alternate hold loading",
      type: "choice",
      required: true,
      choices: ["yes", "no"],
    },
    {
      section: 2,
      key: "ballastWaterTreatmentSystem",
      label: "BWTS fitted",
      type: "choice",
      required: true,
      choices: ["yes", "no"],
    },
    {
      section: 2,
      key: "isTheSystemAbleToWorkInFreshWater",
      label: "BWTS freshwater capability",
      type: "choice",
      required: true,
      choices: ["yes", "no"],
    },
    {
      section: 2,
      key: "fittedWithShaftPowerMeter",
      label: "Shaft power meter",
      type: "choice",
      required: true,
      choices: ["yes", "no"],
    },
    {
      section: 2,
      key: "fittedWithMassFlowMetersToMeasureFuelConsumption",
      label: "Mass flow meters",
      type: "choice",
      required: true,
      choices: ["yes", "no"],
    },
    {
      section: 2,
      key: "fittedWithThatisAutomaticallyRecording",
      label: "Performance data recording",
      type: "choice",
      required: true,
      choices: ["yes", "no"],
    },
    {
      section: 2,
      key: "scrubberFitted",
      label: "Scrubber fitted",
      type: "choice",
      required: true,
      choices: ["yes", "no"],
    },
    {
      section: 2,
      key: "portBallastHoldNumber",
      label: "Port ballast hold",
      type: "option",
      required: true,
      choices: ["na", "1", "2", "3", "4", "5", "6", "7"],
    },
    {
      section: 2,
      key: "seaBallastHoldNumber",
      label: "Sea ballast hold",
      type: "option",
      required: true,
      choices: ["na", "1", "2", "3", "4", "5", "6", "7"],
    },
    {
      section: 2,
      key: "ballstingRateUsing",
      label: "Gravity ballasting rate",
      type: "number",
      required: true,
      min: 0,
      minInclusive: true,
      max: 10000,
    },
    {
      section: 2,
      key: "deBallstingRateUsing",
      label: "Gravity de-ballasting rate",
      type: "number",
      required: true,
      min: 0,
      minInclusive: true,
      max: 10000,
    },
    {
      section: 2,
      key: "ballastPumps",
      label: "Ballast pump rate",
      type: "number",
      required: false,
      min: 100,
      max: 10000,
    },
    {
      section: 2,
      key: "deBallastPumps",
      label: "De-ballast pump rate",
      type: "number",
      required: false,
      min: 100,
      max: 10000,
    },
    {
      section: 2,
      key: "ballastPumpsWaterTreatment",
      label: "BWTS ballasting rate",
      type: "number",
      required: true,
      min: 100,
      max: 10000,
    },
    {
      section: 2,
      key: "deballastPumpsWaterTreatment",
      label: "BWTS de-ballasting rate",
      type: "number",
      required: true,
      min: 100,
      max: 10000,
    },
    {
      section: 2,
      key: "requiredSalinityOfWater",
      label: "Required salinity",
      type: "number",
      required: false,
      min: 0,
      max: 340,
    },
    {
      section: 2,
      key: "holdTimeDaysorHours",
      label: "Hold time",
      type: "number",
      required: true,
      min: 0,
    },
    {
      section: 2,
      key: "noofCementHoles",
      label: "Number of cement holes",
      type: "integer",
      required: true,
      min: 0,
      max: 25,
      minInclusive: true,
    },
    {
      section: 2,
      key: "dimensionsOfCementHoles",
      label: "Cement-hole dimensions",
      type: "number",
      required: true,
      min: 0,
      max: 1500,
      minInclusive: true,
    },
    {
      section: 2,
      key: "shipHasEedi",
      label: "EEDI / EEXI",
      type: "choice",
      required: true,
      choices: ["EEDI", "EEXI"],
    },
    {
      section: 2,
      key: "eediEvdirating",
      label: "Attained EEDI / EEXI rating",
      type: "number",
      required: true,
      min: 0,
      max: 20,
    },
    {
      section: 2,
      key: "eediEvdiVrefSpeed",
      label: "EEDI / EEXI Vref",
      type: "number",
      required: true,
      min: 0,
      max: 30,
    },
    {
      section: 2,
      key: "scrubberType",
      label: "Scrubber type",
      type: "option",
      required: true,
      when: {
        section: 2,
        key: "scrubberFitted",
        value: "yes",
      },
      choices: ["OpenLoop", "ClosedLoop", "Hybrid"],
    },
    {
      section: 2,
      key: "scrubberMaker",
      label: "Scrubber maker",
      type: "text",
      required: true,
      when: {
        section: 2,
        key: "scrubberFitted",
        value: "yes",
      },
    },
    {
      section: 2,
      key: "isVesselAuxBoilerConnectedToScrubber",
      label: "Auxiliary boiler connected to scrubber",
      type: "choice",
      required: true,
      when: {
        section: 2,
        key: "scrubberFitted",
        value: "yes",
      },
      choices: ["yes", "no"],
    },
    {
      section: 2,
      key: "noxTierIIIEngineFuelGrade",
      label: "NOx Tier III engine / fuel grade",
      type: "text",
      required: true,
      when: {
        section: 2,
        key: "scrubberFitted",
        value: "yes",
      },
    },
    {
      section: 3,
      key: "summerSWDraft",
      label: "summer draft",
      type: "number",
      required: true,
      min: 5,
      max: 25,
    },
    {
      section: 3,
      key: "summerDWT",
      label: "summer DWT",
      type: "number",
      required: true,
      min: 0,
      max: 400000,
    },
    {
      section: 3,
      key: "summerTPC",
      label: "summer TPC",
      type: "number",
      required: true,
      min: 0,
      max: 400,
    },
    {
      section: 3,
      key: "winterSWDraft",
      label: "winter draft",
      type: "number",
      required: true,
      min: 5,
      max: 25,
    },
    {
      section: 3,
      key: "winterDWT",
      label: "winter DWT",
      type: "number",
      required: true,
      min: 0,
      max: 400000,
    },
    {
      section: 3,
      key: "winterTPC",
      label: "winter TPC",
      type: "number",
      required: true,
      min: 0,
      max: 400,
    },
    {
      section: 4,
      key: "hasUnderwaterHullInspectionAfterLastDrydock",
      label: "Underwater inspection / cleaning after drydock",
      type: "choice",
      required: true,
      choices: ["yes", "no"],
    },
    {
      section: 4,
      key: "underWaterHullCleaningPortNameOne",
      label: "Hull record 1: Port",
      type: "text",
      required: true,
      when: {
        section: 4,
        key: "hasUnderwaterHullInspectionAfterLastDrydock",
        value: "yes",
      },
    },
    {
      section: 4,
      key: "underWateHullCleaningDateOne",
      label: "Hull record 1: Date",
      type: "date",
      required: true,
      when: {
        section: 4,
        key: "hasUnderwaterHullInspectionAfterLastDrydock",
        value: "yes",
      },
    },
    {
      section: 4,
      key: "underWaterHullCleaningHullInspectedOne",
      label: "Hull record 1: Hull inspected",
      type: "choice",
      required: true,
      when: {
        section: 4,
        key: "hasUnderwaterHullInspectionAfterLastDrydock",
        value: "yes",
      },
      choices: ["yes", "no"],
    },
    {
      section: 4,
      key: "underWaterHullCleaningHullCleanedOne",
      label: "Hull record 1: Hull cleaned",
      type: "choice",
      required: true,
      when: {
        section: 4,
        key: "hasUnderwaterHullInspectionAfterLastDrydock",
        value: "yes",
      },
      choices: ["yes", "no"],
    },
    {
      section: 4,
      key: "underWateHullCleaningPropellerPolishedOne",
      label: "Hull record 1: Propeller polished",
      type: "choice",
      required: true,
      when: {
        section: 4,
        key: "hasUnderwaterHullInspectionAfterLastDrydock",
        value: "yes",
      },
      choices: ["yes", "no"],
    },
    {
      section: 4,
      key: "underWaterHullCleaningNzMpiStandardCleaningOne",
      label: "Hull record 1: NZ MPI standard cleaning",
      type: "choice",
      required: true,
      when: {
        section: 4,
        key: "hasUnderwaterHullInspectionAfterLastDrydock",
        value: "yes",
      },
      choices: ["yes", "no"],
    },
    {
      section: 4,
      key: "underWaterHullCleaningPortNameTwo",
      label: "Hull record 2: Port",
      type: "text",
      required: false,
      when: {
        section: 4,
        key: "hasUnderwaterHullInspectionAfterLastDrydock",
        value: "yes",
      },
      requiredWhenAny: [
        "underWaterHullCleaningPortNameTwo",
        "underWateHullCleaningDateTwo",
        "underWaterHullCleaningHullInspectedTwo",
        "underWaterHullCleaningHullCleanedTwo",
        "underWateHullCleaningPropellerPolishedTwo",
        "underWaterHullCleaningNzMpiStandardCleaningTwo",
      ],
    },
    {
      section: 4,
      key: "underWateHullCleaningDateTwo",
      label: "Hull record 2: Date",
      type: "date",
      required: false,
      when: {
        section: 4,
        key: "hasUnderwaterHullInspectionAfterLastDrydock",
        value: "yes",
      },
      requiredWhenAny: [
        "underWaterHullCleaningPortNameTwo",
        "underWateHullCleaningDateTwo",
        "underWaterHullCleaningHullInspectedTwo",
        "underWaterHullCleaningHullCleanedTwo",
        "underWateHullCleaningPropellerPolishedTwo",
        "underWaterHullCleaningNzMpiStandardCleaningTwo",
      ],
    },
    {
      section: 4,
      key: "underWaterHullCleaningHullInspectedTwo",
      label: "Hull record 2: Hull inspected",
      type: "choice",
      required: false,
      when: {
        section: 4,
        key: "hasUnderwaterHullInspectionAfterLastDrydock",
        value: "yes",
      },
      choices: ["yes", "no"],
      requiredWhenAny: [
        "underWaterHullCleaningPortNameTwo",
        "underWateHullCleaningDateTwo",
        "underWaterHullCleaningHullInspectedTwo",
        "underWaterHullCleaningHullCleanedTwo",
        "underWateHullCleaningPropellerPolishedTwo",
        "underWaterHullCleaningNzMpiStandardCleaningTwo",
      ],
    },
    {
      section: 4,
      key: "underWaterHullCleaningHullCleanedTwo",
      label: "Hull record 2: Hull cleaned",
      type: "choice",
      required: false,
      when: {
        section: 4,
        key: "hasUnderwaterHullInspectionAfterLastDrydock",
        value: "yes",
      },
      choices: ["yes", "no"],
      requiredWhenAny: [
        "underWaterHullCleaningPortNameTwo",
        "underWateHullCleaningDateTwo",
        "underWaterHullCleaningHullInspectedTwo",
        "underWaterHullCleaningHullCleanedTwo",
        "underWateHullCleaningPropellerPolishedTwo",
        "underWaterHullCleaningNzMpiStandardCleaningTwo",
      ],
    },
    {
      section: 4,
      key: "underWateHullCleaningPropellerPolishedTwo",
      label: "Hull record 2: Propeller polished",
      type: "choice",
      required: false,
      when: {
        section: 4,
        key: "hasUnderwaterHullInspectionAfterLastDrydock",
        value: "yes",
      },
      choices: ["yes", "no"],
      requiredWhenAny: [
        "underWaterHullCleaningPortNameTwo",
        "underWateHullCleaningDateTwo",
        "underWaterHullCleaningHullInspectedTwo",
        "underWaterHullCleaningHullCleanedTwo",
        "underWateHullCleaningPropellerPolishedTwo",
        "underWaterHullCleaningNzMpiStandardCleaningTwo",
      ],
    },
    {
      section: 4,
      key: "underWaterHullCleaningNzMpiStandardCleaningTwo",
      label: "Hull record 2: NZ MPI standard cleaning",
      type: "choice",
      required: false,
      when: {
        section: 4,
        key: "hasUnderwaterHullInspectionAfterLastDrydock",
        value: "yes",
      },
      choices: ["yes", "no"],
      requiredWhenAny: [
        "underWaterHullCleaningPortNameTwo",
        "underWateHullCleaningDateTwo",
        "underWaterHullCleaningHullInspectedTwo",
        "underWaterHullCleaningHullCleanedTwo",
        "underWateHullCleaningPropellerPolishedTwo",
        "underWaterHullCleaningNzMpiStandardCleaningTwo",
      ],
    },
    {
      section: 4,
      key: "lastDryDockingDate",
      label: "Last drydock / delivery date",
      type: "date",
      required: true,
    },
    {
      section: 4,
      key: "lastDryDockingLocation",
      label: "Last drydock / delivery location",
      type: "text",
      required: true,
    },
    {
      section: 4,
      key: "dateOfIssuanceAntifoulingCertificate",
      label: "Antifouling certificate date",
      type: "date",
      required: true,
    },
    {
      section: 4,
      key: "dateOfPaintApplication",
      label: "Paint application date",
      type: "date",
      required: true,
    },
    {
      section: 4,
      key: "typeOfAntiFoulingSystem",
      label: "Antifouling system type",
      type: "option",
      required: true,
    },
    {
      section: 4,
      key: "antiFoulingSystemManufacturer",
      label: "Antifouling manufacturer",
      type: "option",
      required: true,
    },
    {
      section: 4,
      key: "antiFoulingBootTopCoating",
      label: "Boot top coating",
      type: "text",
      required: true,
    },
    {
      section: 4,
      key: "antiFoulingVerticalBottomCoating",
      label: "Vertical bottom coating",
      type: "text",
      required: true,
    },
    {
      section: 4,
      key: "antiFoulingFlatBottomCoating",
      label: "Flat bottom coating",
      type: "text",
      required: true,
    },
    {
      section: 4,
      key: "nextScheduledDryDocking",
      label: "Next drydock date",
      type: "date",
      required: true,
    },
    {
      section: 4,
      key: "serviceLifeAfsMonths",
      label: "AFS service life (months)",
      type: "number",
      required: true,
      min: 12,
      max: 60,
      minInclusive: true,
      maxInclusive: true,
    },
    {
      section: 4,
      key: "propellerPaintedCoated",
      label: "Propeller painted / coated",
      type: "choice",
      required: true,
      choices: ["yes", "no"],
    },
    {
      section: 6,
      key: "capacity",
      label: "LSFO mixing tank capacity (m³)",
      type: "number",
      required: true,
      min: 0,
      max: 100,
      minInclusive: false,
    },
    {
      section: 6,
      key: "umpumpable",
      label: "LSFO settling tank unpumpable quantity (m³)",
      type: "number",
      required: true,
      min: 0,
      max: 20,
      minInclusive: true,
    },
    {
      section: 6,
      key: "lsfoservicetank",
      label: "LSFO service tank minimum level (%)",
      type: "number",
      required: true,
      min: 0,
      max: 20,
      minInclusive: true,
    },
    {
      section: 6,
      key: "minimalfeasble",
      label: "Service tank draining time (hours)",
      type: "number",
      required: true,
      min: 0,
      max: 24,
      minInclusive: false,
    },
    {
      section: 7,
      key: "propellerPitch",
      label: "Propeller pitch",
      type: "number",
      required: true,
      min: 0,
      max: 12,
    },
    {
      section: 7,
      key: "propellerDiameter",
      label: "Propeller diameter",
      type: "number",
      required: true,
      min: 0,
      max: 13,
    },
    {
      section: 7,
      key: "mainEngineMCRRating",
      label: "Main engine MCR (kW)",
      type: "number",
      required: true,
      min: 0,
      max: 35000,
    },
    {
      section: 7,
      key: "mainEngineNCR",
      label: "Main engine NCR (kW)",
      type: "number",
      required: true,
      min: 0,
      max: 35000,
    },
    {
      section: 7,
      key: "SMCRRating",
      label: "Main engine RPM at MCR",
      type: "number",
      required: true,
      min: 0,
      max: 128,
    },
    {
      section: 7,
      key: "ncrBallast",
      label: "NCR ballast RPM",
      type: "number",
      required: false,
      min: 0,
      max: 128,
    },
    {
      section: 7,
      key: "ncrLaden",
      label: "NCR laden RPM",
      type: "number",
      required: false,
      min: 0,
      max: 128,
    },
    {
      section: 7,
      key: "minSlowSMCR",
      label: "Minimum slow-steaming MCR (%)",
      type: "number",
      required: true,
      min: 0,
      max: 60,
    },
    {
      section: 7,
      key: "blocminSlowSteamingEngine",
      label: "Minimum slow-steaming RPM",
      type: "number",
      required: true,
      min: 0,
      max: 128,
    },
    {
      section: 7,
      key: "criticalRPMUpper",
      label: "Critical RPM upper",
      type: "number",
      required: true,
      min: 0,
      max: 128,
    },
    {
      section: 7,
      key: "criticalRPMLower",
      label: "Critical RPM lower",
      type: "number",
      required: true,
      min: 0,
      max: 128,
    },
    {
      section: 7,
      key: "minUltraSlowSMCR",
      label: "Ultra-slow-steaming MCR (%)",
      type: "number",
      required: false,
      min: 0,
      max: 60,
    },
    {
      section: 7,
      key: "minUltraSlowStreamingRPM",
      label: "Ultra-slow-steaming RPM",
      type: "number",
      required: false,
      min: 0,
      max: 128,
    },
    {
      section: 7,
      key: "auxBlowersCutOFF",
      label: "Blower cut-off pressure",
      type: "number",
      required: true,
      min: 0,
      max: 0.2,
    },
    {
      section: 7,
      key: "auxBlowersPressure",
      label: "Blower cut-in pressure",
      type: "number",
      required: true,
      min: 0,
      max: 0.2,
    },
    {
      section: 7,
      key: "mainEngineSMCRRating",
      label: "Main engine SMCR (kW)",
      type: "number",
      required: false,
    },
    {
      section: 7,
      key: "mainEngineMakerModel",
      label: "Main engine maker and model",
      type: "text",
      required: true,
    },
    {
      section: 7,
      key: "engineEquippedWithPowerLimited",
      label: "Engine power limitation",
      type: "choice",
      required: true,
      choices: ["yes", "no"],
    },
    {
      section: 7,
      key: "isTheVesselFitted",
      label: "Energy-saving devices fitted",
      type: "choice",
      required: true,
      choices: ["yes", "no"],
    },
    {
      section: 7,
      key: "mainEngineLimitedPowerRating",
      label: "Limited engine power (kW)",
      type: "number",
      required: true,
      min: 0,
      max: 35000,
      when: {
        section: 7,
        key: "engineEquippedWithPowerLimited",
        value: "yes",
      },
    },
    {
      section: 7,
      key: "mainEngineRpmAtLimitedPower",
      label: "RPM at limited power",
      type: "number",
      required: true,
      min: 0,
      max: 128,
      when: {
        section: 7,
        key: "engineEquippedWithPowerLimited",
        value: "yes",
      },
    },
    {
      section: 7,
      key: "energySavingDevicesRemarks",
      label: "Energy-saving device details",
      type: "text",
      required: true,
      when: {
        section: 7,
        key: "isTheVesselFitted",
        value: "yes",
      },
    },
    {
      section: 8,
      key: "noOFAuxGensets",
      label: "Number of auxiliary gensets",
      type: "choice",
      required: true,
      choices: ["1", "2", "3", "4"],
    },
    {
      section: 8,
      key: "auxGensetsMakerAndModel",
      label: "Auxiliary genset maker and model",
      type: "text",
      required: true,
    },
    {
      section: 8,
      key: "noxTierIIIComplianceMethod",
      label: "Auxiliary engine NOx Tier III method",
      type: "text",
      required: true,
    },
    {
      section: 8,
      key: "makerTypeHeatingCapacity",
      label: "Boiler maker, type and heating capacity",
      type: "text",
      required: true,
    },
    {
      section: 8,
      key: "auxGensetsPower",
      label: "Auxiliary genset power (kW)",
      type: "number",
      required: true,
      min: 200,
      max: 3000,
    },
    {
      section: 8,
      key: "shaftGeneratorFitted",
      label: "Shaft generator fitted",
      type: "choice",
      required: true,
      choices: ["yes", "no"],
    },
    {
      section: 8,
      key: "shaftGeneratorRatedPower",
      label: "Shaft generator rated power",
      type: "number",
      required: true,
      min: 100,
      max: 3000,
      when: {
        section: 8,
        key: "shaftGeneratorFitted",
        value: "yes",
      },
    },
    {
      section: 8,
      key: "minMainEngineMcrForShaftGenerator",
      label: "Minimum MCR for shaft generator (%)",
      type: "number",
      required: true,
      min: 10,
      max: 80,
      when: {
        section: 8,
        key: "shaftGeneratorFitted",
        value: "yes",
      },
    },
    {
      section: 8,
      key: "auxBoilerConsumption",
      label: "Boiler consumption at 100% load (MT/hr)",
      type: "number",
      required: false,
      min: 0,
      max: 2,
    },
    {
      section: 8,
      key: "normalElectricalLoadAtSea",
      label: "Normal electrical load at sea",
      type: "number",
      required: true,
      min: 100,
      max: 2000,
    },
    {
      section: 8,
      key: "normalElectricalLoadinPortAtAnchor",
      label: "Normal electrical load in port / at anchor",
      type: "number",
      required: true,
      min: 0,
      max: 3000,
    },
    {
      section: 8,
      key: "usualWorkingElectricalLoadatSea",
      label: "Working electrical load at sea",
      type: "number",
      required: true,
      min: 0,
      max: 3000,
    },
    {
      section: 8,
      key: "usualWorkingLoadPortAtAnchor",
      label: "Working electrical load in port / at anchor",
      type: "number",
      required: true,
      min: 0,
      max: 4000,
    },
    {
      section: 8,
      key: "normalAEHFOConsumptionATSea",
      label: "AE fuel consumption at sea",
      type: "number",
      required: true,
      min: 0,
      max: 10,
    },
    {
      section: 8,
      key: "normalLoadAEFOConsumptionInPort",
      label: "Normal load AE fuel consumption in port",
      type: "number",
      required: true,
      requiredFromSchemaVersion: CURRENT_TECH_FORM_SCHEMA_VERSION,
      min: 0,
      minInclusive: true,
      max: 10,
    },
    {
      section: 8,
      key: "mormalFuelConsumptionAuxiliaryBoilerAtSeal",
      label: "Boiler fuel consumption at sea",
      type: "number",
      required: true,
      min: 0,
      minInclusive: true,
      max: 10,
    },
    {
      section: 8,
      key: "normalFuelConsumptionOfBoilerInPort",
      label: "Boiler fuel consumption in port",
      type: "number",
      required: true,
      min: 0,
      max: 10,
    },
  ],
  relations: [
    {
      section: 4,
      key: "dateOfPaintApplication",
      rightSection: 4,
      rightKey: "lastDryDockingDate",
      operator: "dateLt",
      message: "Paint application date must be before the last dry-docking or delivery date",
    },
    {
      section: 7,
      key: "criticalRPMLower",
      rightSection: 7,
      rightKey: "criticalRPMUpper",
      operator: "lt",
      message: "Critical RPM Lower must be less than Critical RPM Upper",
    },
    {
      section: 1,
      key: "heightOfVessel",
      rightSection: 1,
      rightKey: "wlthc.ballast.no1",
      operator: "gt",
      message: "Height of vessel must be greater than every WLTHC value",
    },
    {
      section: 1,
      key: "heightOfVessel",
      rightSection: 1,
      rightKey: "wlthc.ballast.midships",
      operator: "gt",
      message: "Height of vessel must be greater than every WLTHC value",
    },
    {
      section: 1,
      key: "heightOfVessel",
      rightSection: 1,
      rightKey: "wlthc.ballast.last",
      operator: "gt",
      message: "Height of vessel must be greater than every WLTHC value",
    },
    {
      section: 1,
      key: "heightOfVessel",
      rightSection: 1,
      rightKey: "wlthc.fullBallast.no1",
      operator: "gt",
      message: "Height of vessel must be greater than every WLTHC value",
    },
    {
      section: 1,
      key: "heightOfVessel",
      rightSection: 1,
      rightKey: "wlthc.fullBallast.midships",
      operator: "gt",
      message: "Height of vessel must be greater than every WLTHC value",
    },
    {
      section: 1,
      key: "heightOfVessel",
      rightSection: 1,
      rightKey: "wlthc.fullBallast.last",
      operator: "gt",
      message: "Height of vessel must be greater than every WLTHC value",
    },
    {
      section: 1,
      key: "heightOfVessel",
      rightSection: 1,
      rightKey: "wlthc.fullyLaden.no1",
      operator: "gt",
      message: "Height of vessel must be greater than every WLTHC value",
    },
    {
      section: 1,
      key: "heightOfVessel",
      rightSection: 1,
      rightKey: "wlthc.fullyLaden.midships",
      operator: "gt",
      message: "Height of vessel must be greater than every WLTHC value",
    },
    {
      section: 1,
      key: "heightOfVessel",
      rightSection: 1,
      rightKey: "wlthc.fullyLaden.last",
      operator: "gt",
      message: "Height of vessel must be greater than every WLTHC value",
    },
    {
      section: 1,
      key: "loa",
      rightSection: 1,
      rightKey: "lbp",
      operator: "gt",
      message: "LOA must be greater than LBP",
    },
    {
      section: 1,
      key: "totalHoldCapacityGrainM3",
      rightSection: 1,
      rightKey: "totalHoldCapacityBaleM3",
      operator: "gte",
      message: "Grain capacity must be greater than or equal to bale capacity",
    },
    {
      section: 3,
      key: "summerSWDraft",
      rightSection: 3,
      rightKey: "winterSWDraft",
      operator: "gt",
      message: "Summer draft must be greater than winter draft",
    },
    {
      section: 3,
      key: "summerDWT",
      rightSection: 3,
      rightKey: "winterDWT",
      operator: "gt",
      message: "Summer DWT must be greater than winter DWT",
    },
    // Check this on Draft so invalid saved DWT cannot block access from Vessel Details.
    {
      section: 3,
      key: "summerDWT",
      rightSection: 1,
      rightKey: "lightWeight",
      operator: "gt",
      message: "Summer DWT must be greater than lightweight",
    },
    {
      section: 3,
      key: "summerTPC",
      rightSection: 3,
      rightKey: "winterTPC",
      operator: "gte",
      message: "Summer TPC must be greater than or equal to winter TPC",
    },
    {
      section: 7,
      key: "mainEngineLimitedPowerRating",
      rightSection: 7,
      rightKey: "mainEngineMCRRating",
      operator: "lt",
      message: "Limited power must be less than MCR",
      when: {
        section: 7,
        key: "engineEquippedWithPowerLimited",
        value: "yes",
      },
    },
    {
      section: 7,
      key: "mainEngineNCR",
      rightSection: 7,
      rightKey: "mainEngineMCRRating",
      operator: "lt",
      message: "NCR must be less than MCR",
    },
    {
      section: 7,
      key: "ncrBallast",
      rightSection: 7,
      rightKey: "SMCRRating",
      operator: "lt",
      message: "NCR RPM must be less than MCR RPM",
    },
    {
      section: 7,
      key: "ncrLaden",
      rightSection: 7,
      rightKey: "SMCRRating",
      operator: "lt",
      message: "NCR RPM must be less than MCR RPM",
    },
    {
      section: 7,
      key: "auxBlowersPressure",
      rightSection: 7,
      rightKey: "auxBlowersCutOFF",
      operator: "lt",
      message: "Cut-in pressure must be less than cut-off pressure",
    },
  ],
  sections: [1, 2, 3, 4, 6, 7, 8],
  sectionTitles: {
    "1": "Vessel details",
    "2": "Design details",
    "3": "Draft",
    "4": "Antifouling",
    "6": "SECA",
    "7": "Machinery",
    "8": "Power management",
  },
  draftCount: 5,
  draftColumns: [
    {
      key: "draft",
      label: "Draft",
      type: "integer",
      required: true,
      min: 0,
      max: 25,
    },
    {
      key: "dwt",
      label: "DWT",
      type: "number",
      required: true,
      min: 0,
      max: 400000,
    },
    {
      key: "tpc",
      label: "TPC",
      type: "number",
      required: true,
      min: 0,
      max: 400,
    },
  ],
  powerRows: [
    {
      id: 1,
      label: "Ballast Pumps",
      required: true,
    },
    {
      id: 2,
      label: "BWTS",
      required: true,
    },
    {
      id: 3,
      label: "Fire Pump",
      required: true,
    },
    {
      id: 4,
      label: "Air Conditioning Plant",
      required: true,
    },
    {
      id: 5,
      label: "Mechanical Hold Ventilation",
      required: false,
    },
    {
      id: 6,
      label: "Cargo Cranes",
      required: false,
    },
    {
      id: 7,
      label: "Electrical Power of Scrubber Installation",
      required: true,
      when: {
        section: 2,
        key: "scrubberFitted",
        value: "yes",
      },
    },
  ],
  powerFraction: 0.6,
  patterns: {
    decimal: "^[+-]?(?:\\d+(?:[.,]\\d*)?|[.,]\\d+)$",
    imo: "^[1-9]\\d{6}$",
    date: "^(\\d{4})-(\\d{2})-(\\d{2})(?:T.*)?$",
  },
  fakeImo: "0",
};
